
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"-12591.787 2951.001 2.797 12"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"data-name":"Symbol 233 – 131"}},[_c('path',{attrs:{"d":"M-12591.202 2958.402a.883.883 0 0 0 .753.753.761.761 0 0 0 .669-.334 2.658 2.658 0 0 0 .251-.753c.084-1 .418-4.181.5-4.934a4.03 4.03 0 0 0 0-1 1.333 1.333 0 0 0-.753-1 1.627 1.627 0 0 0-1.254 0 1.643 1.643 0 0 0-.751 1.417 6.262 6.262 0 0 0 .084.826c.061.337.334 3.355.417 4.609.043.186.084.416.084.416zm.836 1.84a1.38 1.38 0 0 0-.084 2.76 1.361 1.361 0 0 0 1.422-1.422 1.273 1.273 0 0 0-1.337-1.339z","data-name":"Path 3523","fill":"#f44336"}})])])
          )
        }
      }
    